import { useRef, useEffect } from "react";
import ReactDOM from "react-dom";
function Portal(props) {
    var container = useRef(document.createElement("div"));
    useEffect(function () {
        document.body.appendChild(container.current);
        return function () {
            if (container.current && container.current.parentNode) {
                container.current.parentNode.removeChild(container.current);
            }
        };
    }, []);
    return ReactDOM.createPortal(props.children, container.current);
}
export default Portal;
//# sourceMappingURL=Portal.js.map